/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';


module.exports = function ( app ) {
    var ts       = require('../ts')(app),
        gettext  = require('mag-gettext').gettext;

    return {
        id: 'timeShiftOnExit',
        name: gettext('On exit'),
        description: gettext('Save content on exit (end of TimeShift mode).'),
        icon: 'theme-icon-shortcut',
        data: {
            timeShiftOnExitHandler: 0
        },
        saveImmediate: true,
        prepareForRender: function ( currentValue, callback ) {
            var data = [
                {name: gettext('Do not save buffer'), value: ts.EXIT_NOT_SAVE},
                {name: gettext('Save buffer'), value: ts.EXIT_SAVE}
            ];

            if ( window.top.MODE_PORTAL ) {
                data.push(
                    {name: gettext('Request to save'), value: ts.EXIT_REQUEST_SAVE}
                );
            }

            data.forEach(function ( item ) {
                item.selected = item.value === currentValue.timeShiftOnExitHandler;
            });

            callback(data);
        },
        prepareForSave: function ( value, callback ) {
            this.data.timeShiftOnExitHandler = value;

            // save(value);
            ts.onExit = value;
            callback();
        },
        render: app.api.renders.popupSelect,
        parent: 'timeshift'
    };
};
